// Stub for @mui/icons-material — MUI removed while gantt-task-react still depends on it.
// Remove this stub when @thepocman/gantt-task-react is replaced.
const Stub = () => null;
export const UnfoldLess = Stub;
export const UnfoldMore = Stub;
export const UnfoldMoreDouble = Stub;
export default Stub;
